import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white px-4 py-6 sm:px-6" data-id="element-38" data-mp="1cf9n0fsqcdjp">
      <SectionHeading size="lg" data-id="element-39" data-mp="1ccndiama3nyu">Frequently asked questions</SectionHeading>

      <dl className="mx-auto mt-3.5 max-w-2xl space-y-1" data-id="element-40" data-mp="2a1qj5hpq8l3v">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.q} className="overflow-hidden rounded border border-navy/15 bg-cream" data-id="element-41" data-mp="2039n46bxlgay" data-mpi={index}>
              <dt data-id="element-42" data-mp="1v4pzm1hovwgh">
                <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left transition-colors duration-150 ease-out hover:bg-cream-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-43" data-mp="1v7c4ftd73xv0">
                  <span className="text-[12px] font-extrabold leading-snug text-navy sm:text-[13px]" data-id="element-44" data-mp="1aoiufzsp430j">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-terracotta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-45" data-mp="1fqgm9if5w653" />
                </button>
              </dt>
              <AnimatePresence initial={false} data-id="element-46" data-mp="s0vzeofw0oqj">
                {isOpen && <motion.dd initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-47" data-mp="wyxl7h4p725p">
                    <p className="px-3 pb-2.5 text-[12px] font-medium leading-snug text-graphite sm:text-[13px]" data-id="element-48" data-mp="2kvwz2i88jr4x">
                      {faq.a}
                    </p>
                  </motion.dd>}
              </AnimatePresence>
            </div>;
      })}
      </dl>
    </section>;
}